export default "__VITE_ASSET__DsffFsc7__"